import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-reward-card',
  templateUrl: './reward-card.component.html',
  styleUrls: ['./reward-card.component.scss'],
})
export class RewardCardComponent {
  @Input() membershipLevel = '';
  @Input() holderName = '';
  @Input() points = 0;

  @Output() help = new EventEmitter<void>();
}
